import { Cr as e, qr as t, ut as n } from "./@global-configuration-CBGz_rZL.js";
import { useEffect as r, useMemo as i, useRef as a } from "react";
import { DynamicDataTable as o, DynamicDataTableRowDataType as s, ErrorScreenManager as c, FileConfigTippy as l, IO_VARIABLES_VALUE_COLUMN_BOOL_OPTIONS as u, IO_VARIABLES_VALUE_COLUMN_DATE_OPTIONS as d, ImageWithFallback as f, PATTERNS as p, PluginType as m, Progressing as h, RefVariableType as g, SystemVariableIcon as _, Tooltip as v, VariableTypeFormat as y, abortPreviousRequests as b, getGlobalVariables as x, getGoLangFormattedDateWithTimezone as S, useAsync as C } from "@devtron-labs/devtron-fe-common-lib";
//#region src/Assets/Icons/ic-lego-block.svg?react
var w = t(), T = (e) => /* @__PURE__ */ (0, w.jsxs)("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, w.jsx)("path", {
			d: "M0 4V8.20188C0 8.60883 0.246603 8.97518 0.623624 9.12835L6 11.3125V6.25L0 4Z",
			fill: "#2589C7"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			d: "M12 4V8.20188C12 8.60883 11.7534 8.97518 11.3764 9.12835L6 11.3125V6.25L12 4Z",
			fill: "#0E71AF"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			d: "M6 6.25L0 4L6 1.75L12 4L6 6.25Z",
			fill: "#53ABDB"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.5 2.74951H7.875V4.06189C7.875 4.06193 7.875 4.06197 7.875 4.06201C7.8752 4.30358 8.46275 4.49939 9.1875 4.49939C9.91225 4.49939 10.4998 4.30358 10.5 4.06201C10.5 4.06197 10.5 4.06193 10.5 4.06189V2.74951Z",
			fill: "#1E85C5"
		}),
		/* @__PURE__ */ (0, w.jsx)("ellipse", {
			cx: 9.1875,
			cy: 2.75,
			rx: 1.3125,
			ry: .4375,
			fill: "#6DC4F3"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.125 2.74951H1.5V4.06189C1.5 4.06193 1.5 4.06197 1.5 4.06201C1.5002 4.30358 2.08775 4.49939 2.8125 4.49939C3.53725 4.49939 4.1248 4.30358 4.125 4.06201C4.125 4.06197 4.125 4.06193 4.125 4.06189V2.74951Z",
			fill: "#1E85C5"
		}),
		/* @__PURE__ */ (0, w.jsx)("ellipse", {
			cx: 2.8125,
			cy: 2.75,
			rx: 1.3125,
			ry: .4375,
			fill: "#6DC4F3"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.3125 1.43701H4.6875V2.74939C4.6875 2.74943 4.6875 2.74947 4.6875 2.74951C4.6877 2.99108 5.27525 3.18689 6 3.18689C6.72475 3.18689 7.3123 2.99108 7.3125 2.74951C7.3125 2.74947 7.3125 2.74943 7.3125 2.74939V1.43701Z",
			fill: "#1E85C5"
		}),
		/* @__PURE__ */ (0, w.jsx)("ellipse", {
			cx: 6,
			cy: 1.4375,
			rx: 1.3125,
			ry: .4375,
			fill: "#6DC4F3"
		}),
		/* @__PURE__ */ (0, w.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.3125 3.87451H4.6875V5.18689C4.6875 5.18693 4.6875 5.18697 4.6875 5.18701C4.6877 5.42858 5.27525 5.62439 6 5.62439C6.72475 5.62439 7.3123 5.42858 7.3125 5.18701C7.3125 5.18697 7.3125 5.18693 7.3125 5.18689V3.87451Z",
			fill: "#1E85C5"
		}),
		/* @__PURE__ */ (0, w.jsx)("ellipse", {
			cx: 6,
			cy: 3.875,
			rx: 1.3125,
			ry: .4375,
			fill: "#6DC4F3"
		})
	]
}), E = /* @__PURE__ */ function(e) {
	return e.KEY = "key", e.FORMAT = "format", e.VALUE = "value", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.ADD_ROW = "ADD_ROW", e.UPDATE_ROW = "UPDATE_ROW", e.DELETE_ROW = "DELETE_ROW", e.UPDATE_VALUE_COLUMN = "UPDATE_VALUE_COLUMN", e.UPLOAD_FILE_INFO = "UPLOAD_FILE_INFO", e;
}({}), O = [
	{
		key: E.KEY,
		label: "Key",
		width: "240px"
	},
	{
		key: E.FORMAT,
		label: "Type",
		width: "80px"
	},
	{
		key: E.VALUE,
		label: "Value",
		width: "1fr"
	}
], k = {
	KEY_REQUIRED: "Key is required",
	UNIQUE_KEY: "Keys must be unique"
}, A = {
	VALUE_REQUIRED: "Value is required",
	VALUE_NOT_A_NUMBER: "Value is not a number"
}, j = ({ src: e, isPipelineVar: t, shouldShowInTooltip: n }) => /* @__PURE__ */ (0, w.jsx)(v, {
	alwaysShowTippyOnHover: t,
	content: /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "fs-12 lh-18 flexbox-col dc__gap-2",
		children: [/* @__PURE__ */ (0, w.jsx)("p", {
			className: "m-0 fw-6",
			children: "Pipeline variable"
		}), /* @__PURE__ */ (0, w.jsx)("p", {
			className: "m-0",
			children: "The variable value will be accessible across all tasks in this pipeline execution"
		})]
	}),
	children: /* @__PURE__ */ (0, w.jsx)("div", {
		className: `h-100 flex top dc__no-shrink ${n ? "" : "py-8 pl-8"}`,
		children: /* @__PURE__ */ (0, w.jsx)(f, {
			imageProps: {
				src: typeof e == "string" ? e : "",
				className: "w-20 h-20 p-2",
				width: 20,
				height: 20,
				alt: "plugin-icon"
			},
			fallbackImage: e
		})
	})
}), M = (e) => /* @__PURE__ */ (0, w.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, w.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, w.jsx)("g", { children: /* @__PURE__ */ (0, w.jsx)("g", { children: /* @__PURE__ */ (0, w.jsx)("g", { children: /* @__PURE__ */ (0, w.jsx)("g", { children: /* @__PURE__ */ (0, w.jsxs)("g", {
			transform: "translate(-792 -792) translate(88 707) translate(20 68) translate(520) translate(164 17)",
			children: [
				/* @__PURE__ */ (0, w.jsx)("path", { d: "M0 0H24V24H0z" }),
				/* @__PURE__ */ (0, w.jsx)("path", {
					fill: "#FF6D00",
					fillRule: "nonzero",
					d: "M8.25 4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L8.25 6h-.875c-.38 0-.693.282-.743.648l-.007.102v2.625c0 .977-.509 1.811-1.462 2.534l-.167.122.097.072c.881.68 1.452 1.432 1.524 2.328l.008.194v2.625c0 .38.282.693.648.743l.102.007h.875c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L8.25 20h-.875c-1.463 0-2.658-1.142-2.745-2.582l-.005-.168v-2.625c0-.221-.316-.624-.899-1.046-.248-.18-.52-.346-.79-.493l-.244-.126-.1-.047c-.79-.353-.79-1.473 0-1.826 1.349-.604 1.963-1.177 2.027-1.633l.006-.079V6.75c0-1.463 1.142-2.658 2.582-2.745L7.375 4h.875z"
				}),
				/* @__PURE__ */ (0, w.jsx)("circle", {
					cx: 10,
					cy: 14,
					r: 1,
					fill: "#423BD1"
				}),
				/* @__PURE__ */ (0, w.jsx)("circle", {
					cx: 14,
					cy: 14,
					r: 1,
					fill: "#423BD1"
				}),
				/* @__PURE__ */ (0, w.jsx)("path", {
					fill: "#423BD1",
					fillRule: "nonzero",
					d: "M21.25 4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21.25 6h-.875c-.38 0-.693.282-.743.648l-.007.102v2.625c0 .977-.509 1.811-1.462 2.534l-.167.122.097.072c.881.68 1.452 1.432 1.524 2.328l.008.194v2.625c0 .38.282.693.648.743l.102.007h.875c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21.25 20h-.875c-1.463 0-2.658-1.142-2.745-2.582l-.005-.168v-2.625c0-.221-.316-.624-.899-1.046-.248-.18-.52-.346-.79-.493l-.244-.126-.1-.047c-.79-.353-.79-1.473 0-1.826 1.349-.604 1.963-1.177 2.027-1.633l.006-.079V6.75c0-1.463 1.142-2.658 2.582-2.745L20.375 4h.875z",
					transform: "matrix(-1 0 0 1 37.25 0)"
				})
			]
		}) }) }) }) })
	})
}), N = ({ stepType: e, pluginIcon: t, stepName: n, name: r, description: i }) => /* @__PURE__ */ (0, w.jsxs)("div", {
	className: "fs-12 lh-18",
	children: [
		/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "flex left dc__gap-6 px-10 py-8",
			children: [/* @__PURE__ */ (0, w.jsx)(j, {
				src: R(e, t),
				shouldShowInTooltip: !0
			}), /* @__PURE__ */ (0, w.jsx)("p", {
				className: "m-0 fw-6",
				children: n
			})]
		}),
		/* @__PURE__ */ (0, w.jsx)("div", { className: "w-100 h-1 bcn-6" }),
		/* @__PURE__ */ (0, w.jsxs)("div", {
			className: "flexbox-col dc__gap-2 px-10 py-8",
			children: [/* @__PURE__ */ (0, w.jsx)("p", {
				className: "m-0 fw-6",
				children: r
			}), i && /* @__PURE__ */ (0, w.jsx)("p", {
				className: "m-0",
				children: i
			})]
		})
	]
}), P = (e) => ({ runtimeParams: { runtimePluginVariables: e.filter(({ name: e }) => !!e).map(({ name: e, format: t, value: n, fileMountDir: r, fileReferenceId: i, variableStepScope: a, valueType: o, stepVariableId: s }) => ({
	variableStepScope: a,
	name: e.trim(),
	format: t,
	value: n.trim(),
	fileMountDir: r,
	fileReferenceId: i,
	valueType: o,
	stepVariableId: a === g.GLOBAL ? null : s
})) } }), F = () => Math.floor((/* @__PURE__ */ new Date()).valueOf() * Math.random()), I = ({ format: e, defaultValue: t, valueConstraint: n, globalVariables: r, variableStepScope: i }) => {
	let a = t ? [{
		label: t,
		value: t
	}] : [], o = [], s = (n?.choices || []).map((e) => ({
		label: e,
		value: e
	}));
	e === y.BOOL && s.push(...u), e === y.DATE && o.push(...d);
	let c = r.filter((t) => t.format === e);
	return i === g.GLOBAL || !a.length && !s.length && !o.length && !c.length ? [] : [
		{
			label: "Default value",
			options: a
		},
		{
			label: "Choices",
			options: s
		},
		{
			label: "Supported date formats",
			options: o
		},
		...n?.blockCustomValue ? [] : [{
			label: "System variables",
			options: c
		}]
	];
}, L = ({ format: e, value: t, defaultValue: n, valueConstraint: r, valueType: i, globalVariables: a, variableStepScope: o }) => {
	if (e === y.FILE) return {
		type: s.FILE_UPLOAD,
		value: t,
		props: { fileTypes: r?.constraint?.fileProperty?.allowedExtensions || [] }
	};
	let c = I({
		defaultValue: n,
		format: e,
		valueConstraint: r,
		globalVariables: a,
		variableStepScope: o
	});
	if (c.length) {
		let n = i && i === g.GLOBAL;
		return {
			type: s.SELECT_TEXT,
			value: t,
			props: {
				placeholder: "Enter value or variable",
				options: c,
				isCreatable: e !== y.BOOL && (!r?.choices?.length || !r.blockCustomValue),
				icon: t && n ? /* @__PURE__ */ (0, w.jsx)(_, {}) : null
			}
		};
	}
	return {
		type: s.TEXT,
		value: t,
		props: { placeholder: "Enter value or variable" }
	};
}, R = (e, t) => {
	switch (e) {
		case m.PLUGIN_REF: return t || /* @__PURE__ */ (0, w.jsx)(T, { className: "icon-dim-20 p-2" });
		case m.INLINE: return /* @__PURE__ */ (0, w.jsx)(M, { className: "icon-dim-20 p-2" });
		default: return /* @__PURE__ */ (0, w.jsx)(n, { className: "icon-dim-20 p-2 scn-7" });
	}
}, z = (e, t) => ({
	data: {
		key: {
			value: "",
			type: s.TEXT,
			props: { placeholder: "Enter key" }
		},
		format: {
			value: y.STRING,
			type: s.TEXT,
			disabled: !0,
			props: {}
		},
		value: L({
			format: y.STRING,
			value: "",
			defaultValue: "",
			valueConstraint: null,
			globalVariables: e,
			valueType: g.NEW,
			variableStepScope: g.GLOBAL
		})
	},
	id: t,
	customState: {
		valueType: g.NEW,
		fileReferenceId: null,
		pluginIcon: R(null, ""),
		valueConstraint: null,
		defaultValue: "",
		fileMountDir: "",
		variableStepScope: g.GLOBAL
	}
}), B = ({ parameters: e, globalVariables: t }) => e.length ? e.map(({ stepVariableId: e, name: n, description: r, isRequired: i, format: a, value: o, defaultValue: c, valueType: l, valueConstraint: u, fileReferenceId: d, fileMountDir: f, stepName: p, stepType: m, pluginIcon: h, variableStepScope: _ }) => ({
	data: {
		key: {
			value: n,
			type: s.TEXT,
			disabled: _ !== g.GLOBAL,
			required: i,
			props: { placeholder: "Enter key" },
			tooltip: _ === g.GLOBAL ? null : {
				className: "no-content-padding",
				content: /* @__PURE__ */ (0, w.jsx)(N, {
					name: n,
					stepName: p,
					stepType: m,
					description: r,
					pluginIcon: h
				})
			}
		},
		format: {
			value: a,
			type: s.TEXT,
			disabled: !0,
			props: {}
		},
		value: L({
			format: a,
			value: o,
			defaultValue: c,
			valueConstraint: u,
			globalVariables: t,
			valueType: l,
			variableStepScope: _
		})
	},
	id: e,
	disableDelete: i,
	customState: {
		defaultValue: c,
		valueType: l ?? g.NEW,
		fileReferenceId: d,
		fileMountDir: f,
		pluginIcon: R(m, h),
		valueConstraint: u,
		variableStepScope: _
	}
})) : [z(t, 0)], V = ({ runtimeParameters: e, runtimePluginVariables: t }) => e.map(({ data: e, id: n, customState: r }) => {
	let i = t.find(({ stepVariableId: e }) => e === n);
	return {
		...i,
		stepVariableId: i?.stepVariableId ?? +n,
		valueType: r.valueType,
		variableStepScope: r.variableStepScope,
		name: e.key.value,
		format: e.format.value,
		value: e.value.value,
		fileReferenceId: r.fileReferenceId
	};
}), H = ({ name: e, variableStepScope: t, format: n, stepName: r }) => t ? `${e}-${n}-${t}-${r}` : `${e}-${n}`, U = (e, t, n) => e.reduce((e, r) => {
	let i = !r.data.key.disabled && (r.id === t ? n : r.data.key.value);
	return i && (e[i] = (e[i] || 0) + 1), e;
}, {}), W = () => ({
	[E.KEY]: {
		isValid: !0,
		errorMessages: []
	},
	[E.FORMAT]: {
		isValid: !0,
		errorMessages: []
	},
	[E.VALUE]: {
		isValid: !0,
		errorMessages: []
	}
}), G = ({ rows: e, rowId: t, value: n, cellError: r }) => {
	let i = r, a = U(e, t, n);
	e.forEach(({ data: e, id: r }) => {
		let o = t === r ? n : e.key.value, s = i[r].key;
		s.isValid && a[o] > 1 ? i[r].key = {
			isValid: !1,
			errorMessages: [k.UNIQUE_KEY]
		} : a[o] < 2 && s.errorMessages[0] === k.UNIQUE_KEY && (i[r].key = {
			isValid: !0,
			errorMessages: []
		});
	});
}, K = ({ runtimePluginVariable: e, key: t, keysFrequencyMap: n = {} }) => {
	let { isRequired: r, name: i, value: a, format: o, variableStepScope: s, stepName: c } = e;
	if (t === E.KEY) {
		if (a && !i) return {
			isValid: !1,
			errorMessages: [k.KEY_REQUIRED]
		};
		if ((n[H({
			name: i,
			format: o,
			variableStepScope: s,
			stepName: c
		})] || 0) > 1) return {
			isValid: !1,
			errorMessages: [k.UNIQUE_KEY]
		};
	}
	if (t === E.VALUE) {
		if (r && !a) return {
			isValid: !1,
			errorMessages: [A.VALUE_REQUIRED]
		};
		if (o === y.NUMBER && a && !p.NUMBERS_WITH_SCOPE_VARIABLES.test(a)) return {
			isValid: !1,
			errorMessages: [A.VALUE_NOT_A_NUMBER]
		};
	}
	return {
		isValid: !0,
		errorMessages: []
	};
}, q = (e) => {
	let t = {
		isValid: !0,
		cellError: {}
	}, n = (e ?? []).reduce((e, t) => {
		let n = H({
			name: t.name,
			format: t.format,
			variableStepScope: t.variableStepScope,
			stepName: t.stepName
		});
		return n && (e[n] = (e[n] || 0) + 1), e;
	}, {}), r = !0;
	return t.cellError = (e ?? []).reduce((e, t) => (e[t.stepVariableId] = O.reduce((e, { key: i }) => {
		let a = K({
			runtimePluginVariable: t,
			key: i,
			keysFrequencyMap: n
		});
		return r &&= a.isValid, {
			...e,
			[i]: a
		};
	}, {}), e), {}), t.isValid = r, t;
}, J = ({ key: e, row: { data: t }, value: n }) => {
	let r = n ?? t[e].value, i = t.key.required;
	return K({
		key: e,
		runtimePluginVariable: {
			isRequired: i,
			name: e === E.KEY ? r : t.key.value,
			value: e === E.VALUE ? r : t.value.value,
			format: t.format.value
		}
	});
}, Y = (e) => Object.values(e).reduce((e, t) => e && !Object.values(t).some((e) => !e.isValid), !0), X = ({ appId: t, heading: n, parameters: u, handleChange: d, errorState: f = {
	cellError: {},
	isValid: !0
}, handleError: p, uploadFile: m, isCD: _ = !1, hideHeading: T = !1 }) => {
	let { cellError: k } = f, A = a(new AbortController()), [M, N, P, I] = C(() => b(() => x({
		appId: t,
		isCD: _,
		abortControllerRef: A
	}), A), [t, _]);
	r(() => () => {
		A.current.abort();
	}, []);
	let R = i(() => M ? [] : B({
		parameters: u,
		globalVariables: N || []
	}), [
		M,
		N,
		u
	]);
	r(() => {
		let e = (u ?? []).reduce((e, t) => (e[t.stepVariableId] || (e[t.stepVariableId] = O.reduce((e, { key: t }) => ({
			...e,
			[t]: {
				isValid: !0,
				errorMessages: []
			}
		}), {})), e), k);
		(u ?? []).length || (e[0] = W()), p?.({
			isValid: Y(e),
			cellError: e
		});
	}, []);
	let H = (e) => {
		d(V({
			runtimeParameters: e,
			runtimePluginVariables: u
		}));
	}, U = (e) => {
		let { actionType: t } = e, n = R, r = R.findIndex((t) => t.id === e.rowId), i = R[r], a = structuredClone(k);
		switch (t) {
			case D.ADD_ROW:
				n = [z(N || [], e.rowId), ...n], a[e.rowId] = W();
				break;
			case D.UPDATE_ROW:
				if (i) {
					let { id: t } = i;
					a[t][e.headerKey] = J({
						key: e.headerKey,
						value: e.actionValue,
						row: i
					}), e.headerKey === E.KEY && G({
						rows: R,
						cellError: a,
						rowId: e.rowId,
						value: e.actionValue
					}), i.data[e.headerKey].value = e.actionValue;
				}
				break;
			case D.DELETE_ROW:
				if (n = n.filter((t) => t.id !== e.rowId), delete a[e.rowId], G({
					rows: n,
					cellError: a
				}), n.length === 0) {
					let e = z(N || [], F());
					n.push(e), a[e.id] = {};
				}
				break;
			case D.UPDATE_VALUE_COLUMN:
				if (i) {
					let { id: t, data: n, customState: r } = i, o = e.actionValue.value && n.format.value === y.DATE ? S(e.actionValue.selectedValue.value) : e.actionValue.value;
					a[t].value = J({
						key: E.VALUE,
						value: o,
						row: i
					}), i.data.value = L({
						format: n.format.value,
						globalVariables: N || [],
						value: o,
						defaultValue: r.defaultValue,
						valueConstraint: r.valueConstraint,
						valueType: e.actionValue.selectedValue?.variableType ?? g.NEW,
						variableStepScope: r.variableStepScope
					}), i.customState.valueType = e.actionValue.selectedValue?.variableType ?? g.NEW;
				}
				break;
			case D.UPLOAD_FILE_INFO:
				if (i && i.data.value.type === s.FILE_UPLOAD) {
					let { id: t } = i;
					a[t].value = J({
						key: E.VALUE,
						value: e.actionValue.fileName,
						row: i
					}), i.data.value.value = e.actionValue.fileName, i.data.value.props.isLoading = e.actionValue.isLoading, i.customState.fileReferenceId = e.actionValue.fileReferenceId;
				}
				break;
			default: break;
		}
		t !== D.ADD_ROW && t !== D.DELETE_ROW && r > -1 && (n[r] = i), H(n), p?.({
			isValid: Y(a),
			cellError: a
		});
	};
	return M ? /* @__PURE__ */ (0, w.jsx)(h, { size: 32 }) : P ? /* @__PURE__ */ (0, w.jsx)(c, {
		code: P.code,
		reload: I
	}) : /* @__PURE__ */ (0, w.jsxs)("div", {
		className: "flexbox-col dc__gap-16",
		children: [!T && /* @__PURE__ */ (0, w.jsxs)("div", {
			className: "flex left dc__gap-4",
			children: [/* @__PURE__ */ (0, w.jsx)("h2", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: n || "Runtime Parameters"
			}), /* @__PURE__ */ (0, w.jsx)(v, {
				alwaysShowTippyOnHover: !0,
				content: "Parameters (key:value) will be passed as environment variables",
				children: /* @__PURE__ */ (0, w.jsx)("div", {
					className: "icon-dim-20 flex dc__tab-focus",
					children: /* @__PURE__ */ (0, w.jsx)(e, { className: "icon-dim-20 dc__no-shrink" })
				})
			})]
		}), /* @__PURE__ */ (0, w.jsx)(o, {
			headers: O,
			rows: R,
			onRowAdd: () => {
				U({
					actionType: D.ADD_ROW,
					rowId: F()
				});
			},
			onRowDelete: (e) => {
				U({
					actionType: D.DELETE_ROW,
					rowId: e.id
				});
			},
			onRowEdit: async (e, t, n, { files: r, selectedValue: i }) => {
				if (t === E.VALUE && e.data.value.type === s.SELECT_TEXT) U({
					actionType: D.UPDATE_VALUE_COLUMN,
					rowId: e.id,
					actionValue: {
						value: n,
						selectedValue: i
					}
				});
				else if (t === E.VALUE && e.data.format.value === y.FILE) {
					if (U({
						actionType: D.UPLOAD_FILE_INFO,
						rowId: e.id,
						actionValue: {
							fileReferenceId: null,
							isLoading: !1,
							fileName: n
						}
					}), r.length) try {
						U({
							actionType: D.UPLOAD_FILE_INFO,
							rowId: e.id,
							actionValue: {
								fileReferenceId: null,
								isLoading: !0,
								fileName: n
							}
						});
						let { id: t } = await m({ file: r });
						U({
							actionType: D.UPLOAD_FILE_INFO,
							rowId: e.id,
							actionValue: {
								fileReferenceId: t,
								isLoading: !1,
								fileName: n
							}
						});
					} catch {
						U({
							actionType: D.UPLOAD_FILE_INFO,
							rowId: e.id,
							actionValue: {
								fileReferenceId: null,
								isLoading: !1,
								fileName: ""
							}
						});
					}
				} else U({
					actionType: D.UPDATE_ROW,
					headerKey: t,
					rowId: e.id,
					actionValue: n
				});
			},
			leadingCellIcon: { key: ({ customState: e, data: t }) => /* @__PURE__ */ (0, w.jsx)(j, {
				isPipelineVar: !t.key.disabled,
				src: e.pluginIcon
			}) },
			trailingCellIcon: { value: (e) => e.data.format.value === y.FILE ? /* @__PURE__ */ (0, w.jsx)(l, { fileMountDir: e.customState.fileMountDir }) : null },
			cellError: k
		})]
	});
};
//#endregion
export { T as i, P as n, q as r, X as t };
